import { css } from "@emotion/react";
import { ImageSwiper } from "../molecules";

const images1 = [
  "/img/KS_commentcard_240617_iso.jpg",
  "/img/KS_commentcard_240617_kaibashira.jpg",
  "/img/KS_commentcard_240617_kengo.jpg",
  "/img/KS_commentcard_240617_matsuzaki.jpg",
  "/img/KS_commentcard_240617_nakai.jpg",
];
const images2 = [
  "/img/KS_commentcard_240617_namaniku.jpg",
  "/img/KS_commentcard_240617_remu.jpg",
  "/img/KS_commentcard_240617_saito.jpg",
  "/img/KS_commentcard_240617_shinnosuke.jpg",
  "/img/KS_commentcard_240617_syo.jpg",
  "/img/KS_commentcard_240617_tahara.jpg",
];

const Impressoins: React.FC = () => {
  const imageHeight = (window.innerWidth * 1875) / 2500;
  return (
    <div css={container(imageHeight * 2 - 2)}>
      <ImageSwiper images={images1} slidesPerView={1} speed={15000} />
      <ImageSwiper
        images={images2}
        slidesPerView={1}
        speed={15000}
        rtl
        top={-5}
      />
    </div>
  );
};

const container = (height: number) => css`
  height: ${height}px;
  overflow: hidden;
  position: relative;
`;

export default Impressoins;
